import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import slide01 from "@/assets/popup/slide-01.jpg";
import slide03 from "@/assets/popup/slide-03.jpg";
import slide04 from "@/assets/popup/slide-04.jpg";
import slide06 from "@/assets/popup/slide-06.jpg";
import slide07 from "@/assets/popup/slide-07.jpg";
import slide10 from "@/assets/popup/slide-10.jpg";
import slide12 from "@/assets/popup/slide-12.jpg";
import slide13 from "@/assets/popup/slide-13.jpg";
import slide14 from "@/assets/popup/slide-14.jpg";
import slide15 from "@/assets/popup/slide-15.jpg";
import slide17 from "@/assets/popup/slide-17.jpg";
import slide18 from "@/assets/popup/slide-18.jpg";
interface ImagePopupProps {
  isOpen: boolean;
  onClose: () => void;
  imageType?: "realistic" | "anime" | "render";
  onAction?: () => void;
}
const realisticSlides = [
  slide01,
  "https://assets.loverslabs.art/Galeria01/hfghfghfdghfdgh.jpg",
  slide03,
  slide04,
  "https://assets.loverslabs.art/popuploverslabs/fgjhgjgfhjg.jpg",
  "https://assets.loverslabs.art/popuploverslabs/5i86fiuuk1.jpg",
  slide06,
  slide07,
  "https://assets.loverslabs.art/popuploverslabs/cPLOKp5P2Gv56fk9RpJF.jpg",
  "https://assets.loverslabs.art/popuploverslabs/5i86fiuukt.jpg",
  slide10,
  "https://assets.loverslabs.art/popuploverslabs/5i86fiuukt.ucarecd.jpg",
  slide12,
  slide13,
  slide14,
  slide15,
  "https://assets.loverslabs.art/popuploverslabs/O5uzWGmmfkSda7NeGB84.jpg",
  slide17,
  slide18,
];
const animeSlides = [
  "https://assets.loverslabs.art/anime/anime/WivwomIaPOHyrrbZLAhF.jpg",
  "https://assets.loverslabs.art/popuploverslabs/c29422df-f76f-4bd9-9e2b-bae13780939a.webp",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd27.jpg",
  "https://assets.loverslabs.art/popuploverslabs/LoversLabsMJ3QYXJ17DD5SDJY.webp",
  "https://assets.loverslabs.art/anime/8AFIFF30sI0LvLJZscOX.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd24.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd17.jpg",
  "https://assets.loverslabs.art/popuploverslabs/DHGDHGD.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd31.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd29.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd9.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd18.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd48.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd49.jpg",
  "https://assets.loverslabs.art/anime/anime/1.jpg",
  "https://assets.loverslabs.art/anime/anime/2.jpg",
  "https://assets.loverslabs.art/anime/anime/3.jpg",
];
const renderSlides = [
  "https://assets.loverslabs.art/render/aOjMCTyRBnjNHE2WbGdA.jpg",
  "https://assets.loverslabs.art/render/render%202/Nova%20pasta/w2xfbxnhdp.ucarecd11.jpg",
  "https://assets.loverslabs.art/render/render%202/Nova%20pasta/w2xfbxnhdp.ucarecd28.jpg",
  "https://assets.loverslabs.art/render/GDFGDFD.jpg",
  "https://assets.loverslabs.art/popuploverslabs/hcKJjEfJzrC9iB3PXnrp.jpg",
  "https://assets.loverslabs.art/render/HFDGDFH.jpg",
  "https://assets.loverslabs.art/render/hmRtsmYeaQf7AziCNE0f.jpg",
  "https://assets.loverslabs.art/render/wgwJsvKL5i6OV4QTtBUw.jpg",
  "https://assets.loverslabs.art/render/AZ1RkAMVP0gydLxouTu7.jpg",
  "https://assets.loverslabs.art/render/render%202/Nova%20pasta/w2xfbxnhdp.ucarecd45.jpg",
  "https://assets.loverslabs.art/render/render%202/Nova%20pasta/w2xfbxnhdp.ucarecd8.jpg",
  "https://assets.loverslabs.art/render/render%202/Nova%20pasta/w2xfbxnhdp.ucarecd53.jpg",
  "https://assets.loverslabs.art/render/render%202/6.jpg",
  "https://assets.loverslabs.art/render/render%202/7.jpg",
  "https://assets.loverslabs.art/render/render%202/8.jpg",
  "https://assets.loverslabs.art/render/40rQ9NFeCL7AVSsAeFoC.jpg",
  "https://assets.loverslabs.art/render/sNz0YNB59OwV2nw7bo1A1.jpg",
  "https://assets.loverslabs.art/render/render%202/9.jpg",
  "https://assets.loverslabs.art/render/render%202/10.jpg",
];
const ImagePopup: React.FC<ImagePopupProps> = ({ isOpen, onClose, imageType = "realistic", onAction }) => {
  const slideImages = imageType === "anime" ? animeSlides : imageType === "render" ? renderSlides : realisticSlides;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [timerKey, setTimerKey] = useState(0);

  // Resetar para primeira imagem quando o popup abre
  useEffect(() => {
    if (isOpen) {
      setCurrentSlide(0);
      setTimerKey(0);
    }
  }, [isOpen]);

  // Preload images
  useEffect(() => {
    slideImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [imageType]);

  // Timer automático - reseta quando timerKey muda
  useEffect(() => {
    if (!isOpen) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [isOpen, slideImages.length, timerKey]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyboard = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") handlePrev();
      if (e.key === "ArrowRight") handleNext();
    };
    window.addEventListener("keydown", handleKeyboard);
    return () => window.removeEventListener("keydown", handleKeyboard);
  }, [isOpen, currentSlide]);

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slideImages.length) % slideImages.length);
    setTimerKey((prev) => prev + 1);
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slideImages.length);
    setTimerKey((prev) => prev + 1);
  };

  const handleDotClick = (index: number) => {
    setCurrentSlide(index);
    setTimerKey((prev) => prev + 1);
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full p-0 rounded-lg overflow-hidden animate-fade-in">
        <div className="relative">
          <div className="aspect-video w-full relative overflow-hidden rounded-t-lg">
            {slideImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-700 ease-in-out will-change-[opacity] ${index === currentSlide ? "opacity-100" : "opacity-0"}`}
              />
            ))}

            {/* Arrow Navigation - Lateral Quadrado */}
            <button
              onClick={handlePrev}
              className="absolute left-0 top-1/2 -translate-y-1/2 
                w-8 h-16 sm:w-10 sm:h-20 rounded-r-sm 
                bg-black/40 backdrop-blur-md border-r border-y border-white/15 
                flex items-center justify-center 
                transition-all duration-300 
                hover:bg-black/60 hover:border-white/30
                active:scale-95 shadow-lg"
              aria-label="Previous slide"
            >
              <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6 text-white drop-shadow-md" />
            </button>
            <button
              onClick={handleNext}
              className="absolute right-0 top-1/2 -translate-y-1/2 
                w-8 h-16 sm:w-10 sm:h-20 rounded-l-sm 
                bg-black/40 backdrop-blur-md border-l border-y border-white/15 
                flex items-center justify-center 
                transition-all duration-300 
                hover:bg-black/60 hover:border-white/30
                active:scale-95 shadow-lg"
              aria-label="Next slide"
            >
              <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 text-white drop-shadow-md" />
            </button>

            {/* Dot Indicators - Animated Pills with Progress */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-black/30 backdrop-blur-sm rounded-full px-3 py-2">
              {slideImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleDotClick(index)}
                  className={`relative h-2 rounded-full transition-all duration-300 ease-out overflow-hidden ${
                    index === currentSlide ? "w-6 bg-white/30" : "w-2 bg-white/50 hover:bg-white/80"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                >
                  {index === currentSlide && (
                    <span
                      key={`progress-${currentSlide}-${timerKey}`}
                      className="absolute inset-0 bg-primary rounded-full origin-left shadow-[0_0_10px_hsl(var(--primary)/0.6)]"
                      style={{
                        animation: "progress-fill 3.5s linear forwards",
                      }}
                    />
                  )}
                </button>
              ))}
            </div>
          </div>

          <div className="p-6 text-center bg-background gradient-premium border-t">
            <DialogHeader className="mb-4">
              <DialogTitle className="text-3xl font-bold gradient-premium bg-clip-text animate-fade-in"></DialogTitle>
            </DialogHeader>
            <p
              style={{
                animationDelay: "0.1s",
              }}
              className="mb-6 animate-fade-in text-lg text-slate-50"
            >
              Unleash your imagination with the world’s most powerful NSFW AI.
            </p>
            <Button
              variant="gradient"
              size="lg"
              className="px-8 animate-pulse-glow hover:scale-110 transition-transform duration-300"
              onClick={() => {
                onClose();
                onAction?.();
              }}
            >
              Start Now
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default ImagePopup;
